export default {
    documentsHeader: 'Dokumente',
    linksHeader: 'Links',
    noDocumentsFound: 'Keine Dokumente vorhanden',
    clipboard: 'Link erfolgreich in Zwischenablage kopiert!'
};